import { http as httpFileManagement, httpAttachments } from "../httpFileManagement";
import { http as httpMain } from "../httpMain";
import { httpNotification, httpAttachments as httpAttachmentsNotification } from "../httpNotification";

const addInterceptor = (instance: any) => {
    instance.interceptors.request.use((config: any) => {
        config.headers["x-api-key"] = process.env.REACT_APP_API_KEY;
        return config;
    });
};

export const setupInterceptors = () => {
    addInterceptor(httpMain);
    addInterceptor(httpFileManagement);
    addInterceptor(httpAttachments);
    addInterceptor(httpNotification);
    addInterceptor(httpAttachmentsNotification);
}